<template>
  <div class="container mainContent">
    <!-- <div>
      <h4>ขณะเกิดปัญหาที่ตัวระบบ จึงขอทำการปิดระบบชั่วคราว</h4>
      <h4>เเละจะเปิดระบบให้ลงทะเบียนอีกครั้ง เร็วๆนี้</h4>
      <h4>ผู้ที่ลงทะเบียนล่วงหน้าก่อนหน้านี้ จะต้องทำการลงทะเบียนใหม่อีกครั้ง</h4>
      <h4>ขออภัยมา ณ ที่นี้</h4>
    </div> -->

    <div class="d-flex justify-content-center h-100">
      <div class="card">
        <div class="card-header">
          <h4>เข้าสู่ระบบ</h4>
          <h4>เพื่อสมัครเข้าร่วมกิจกรรม</h4>
        </div>
        <div class="card-body">
          <form>
            <div class="card-body">
              <form>
                <div class="input-group form-group">
                  <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fas fa-user"></i></span>
                  </div>
                  <input type="text" v-model="username" class="form-control" placeholder="หมายเลขผู้ลงทะเบียน">
                </div>
                <div class="input-group form-group">
                  <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fas fa-key"></i></span>
                  </div>
                  <input type="password" v-model="password" class="form-control" placeholder="รหัสผ่าน">
                </div>
                <div class="text-right">
                  <a @click="login()" class="btn btn-primary">เข้าสู่ระบบ</a>
                </div>
                <div class="text-left mt-1">
                  <p class="mb-1">คุณยังไม่ได้ลงทะเบียน?</p>
                  <a id="registerButton" @click="register()" class="btn btn-primary">ลงทะเบียนเพื่อรับรหัสผ่าน</a>
                </div>
              </form>
            </div>
          </form>
        </div>
      </div>
    </div>

  <div v-if="showModal">
    <transition name="modal">
    <div class="modal-mask">
        <div class="modal-wrapper">

        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title req-field">เเจ้งเตือน</h5>
                    <button  class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" @click="showModal = false">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{ modalmsg }}</p>
                </div>
                <div v-if="this.isSubmit == true" class="modal-footer">
                    <a id="" @click="yes()" class="btn btn-primary mt-2">ใช่</a>
                    <a id="" @click="no()" class="btn btn-primary mt-2">ไม่ใช่ฉัน</a>
                </div>
                <div v-if="this.isSubmitIsNo == true" class="modal-footer">
                    <a id="" @click="register()" class="btn btn-primary mt-2">ลงทะเบียน</a>
                </div>
            </div>
        </div>

        </div>
    </div>
    </transition>
  </div>

  </div>

</template>

<script>
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import { mapGetters, mapActions } from 'vuex';

Vue.use(BootstrapVue);
export default {
  name: "LogInCard",
  data: () => {
    return {
      username: "",
      password: "",
      modalmsg: "",
      showModal: false,
      isSubmit: false,
      isSubmitIsNo: false,
      loginResult: ""
    }
  },
  methods: {
    ...mapGetters([
      'getToken'
    ]),
    ...mapActions({
      loginActions: 'login'
    }),
    login() {

      let payload = {
        username: this.username,
        password: this.password
      }

      this.modalmsg = "กำลังเข้าสู่ระบบกรุณารอซักครู่"
      this.showModal = true;

      // console.log(this.username.length);
      if (this.username.length < 6 || this.password.length < 6) {
        this.modalmsg = "คุณใส่รหัสผ่านไม่ถูกต้อง"
        this.showModal = true;
        return ""
      }
      // console.log((parseInt(this.username.slice(1, 6))))
      // console.log(this.username[0])
      if ((parseInt(this.username.slice(1, 6))) >= 183 && (parseInt(this.username.slice(1, 6))) <= 10000) {
        // console.log((parseInt(this.username.slice(1, 6))) > 182)
        // console.log((parseInt(this.username.slice(1, 6))))
        this.no();
        return ""
      }

      // console.log(payload)
      this.loginActions(payload)
      .then((res) => {
        // console.log(res)
        // console.log(res.data)

        if ((parseInt(this.username.slice(1, 6))) >= 10001 && (this.username[0] == 'K')) {
          this.$router.push('/workshop')
          localStorage.setItem('token', res.token)
        } else if (this.username[0] == 'S') {
          this.$router.push('/staff')
          localStorage.setItem('token', res.token)
        }
        else {
          this.loginActions(payload)
          this.loginResult = res.message;
          this.isSubmit = true;
          this.isSubmitIsNo = false;
          this.modalmsg =  "นี่ใช่ชื่อที่คุณลงทะเบียนหรือไม่ " + res.name + " " + res.surname;
          this.showModal = true;
        }
      })
      .catch((err) => {
        console.log(err)
        this.loginResult = err.data.message;
        this.isSubmit = true;
        this.isSubmitIsNo = false;
        this.modalmsg =  "นี่ใช่ชื่อที่คุณลงทะเบียนหรือไม่ " + err.data.name + " " + err.data.surname;
        this.showModal = true;
      })
    },
    register() {
      this.isSubmitIsNo = false;
      this.$router.push('/register')
    },

    yes() {
      this.isSubmit = false;
      if (this.loginResult == "Login success") {
        this.$router.push('/workshop')
        localStorage.setItem('token', this.getToken())
      } else {
        this.modalmsg =  "คุณใส่รหัสผ่านผิด";
        this.showModal = true;
        this.isSubmit = false;
      }
    },
    no() {
      this.isSubmit = false;
      this.modalmsg =  "เกิดข้อผิดพลาดที่ระบบลงทะเบียน ทำให้ข้อมูลของคุณสูญหาย กรุณาลงทะเบียนใหม่อีกครั้ง ขออภัยอย่างสูงมา ณ ที่นี้";
      this.showModal = true;
      this.isSubmit = false;
      this.isSubmitIsNo = true;
    }
  }
}

</script>

<style lang="scss" scoped>
.modal-title {
    color: #ee4b23;
}
p {
  margin: 0;
}
#registerButton {
  width: 100%;
}
.btn-primary {
  color: #fff;
  background-color: #ee4b23 !important;
  border-color: #ee4b23 !important;
  cursor: pointer;
}
a:not([href]):not([tabindex]) {
  color: #fff;
  text-decoration: none;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .9s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.mainContent {
  min-height: calc(100vh - 314px) ;
}
</style>
